export class SoDeadStockDetails{
    variantCode:string;
    weightInLbs:string;
    date:string;
    days: string;
}